/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import gql from 'graphql-tag';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionModal from 'components/QuickPromotionModal';
import { graphql } from 'react-apollo';
import { mountModal } from 'lib/modal';
import { handleResponse } from 'lib/QuickPromotionActionHandler';
import { ResponseTypes } from 'constants/QuickPromotionConstants';

type Props = {
  emailToken: string,
  promotion?: ?Object,
};

export class MergeSisAccountsModals extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (this.shouldShow(this.props)) {
      this.show();
    }
  }

  // This is a very dated implementation of a modal unfortunately,
  // and the closing mechanisms are not working properly.
  // Since this modal depends on the presence of `emailToken` to be displayed,
  // we can fix the behavior by doing this pretty old way of diffing props
  // and doing something when they change. In this case, we show if emailToken now is truthy,
  // or we hide if the opposite.
  // The `emailToken` is removed by the contents of the modal.
  componentDidUpdate(prevProps: Props) {
    const shouldShow = this.shouldShow(this.props);
    const shouldHide = !shouldShow;
    const wasHiding = !this.shouldShow(prevProps);
    const wasShowing = !wasHiding;

    if (wasHiding && shouldShow) {
      this.show();
    }

    if (wasShowing && shouldHide) {
      this.hide();
    }
  }

  unmountModal = () => {};

  shouldShow = (props: Props): boolean => {
    return !!(props.promotion && props.emailToken);
  };

  stripQuery = () => {
    const { router } = this.context;
    router.replace(router.location.pathname);
  };

  handleConfirm = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION, {
      email_confirmation_token: this.props.emailToken,
    });
    this.stripQuery();
  };

  handleCancel = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.SECONDARY_ACTION);
    this.stripQuery();
  };

  show = () => {
    // this is just to make flow understand
    // as it will never hapen due to how we check promotion
    // before calling this method
    const { promotion } = this.props;
    if (!promotion) {
      return;
    }

    const modal = (
      <QuickPromotionModal
        triggeredContext={'quick_promotions:' + promotion.getPromotion()}
        promotion={promotion}
        onConfirm={this.handleConfirm}
        onCancel={this.handleCancel}
        onRequestHide={() => {}}
      />
    );
    this.unmountModal = mountModal(modal, this);
  };

  hide = () => {
    this.unmountModal();
  };

  render() {
    return null;
  }
}

const withData = graphql(
  gql`
    query FetchSisMergeQP {
      me {
        id
        uuid
        quick_promotions(selectPromotions: ["sis_merge_existing_accounts"]) {
          promotion
          schema_version
          end_date
          type
          trigger
          header
          body
          image_url
          image_type
          primary_action {
            label
            action
            action_data
          }
          secondary_action {
            label
            action
            action_data
          }
        }
      }
    }
  `,
  {
    props: ({ data }) => {
      if (data.error) {
        return {};
      }
      return data.me ? { promotion: QuickPromotion.fromJSON(data.me.quick_promotions[0]) } : {};
    },
  }
);

export default withData(MergeSisAccountsModals);
